var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'l-container': _vm.$env === 'development' },attrs:{"id":"app"}},[_c('contact-form',{attrs:{"fromComponent":"contact"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }